import { Component, OnInit } from '@angular/core';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { AnalysisToolService } from 'src/app/services/analysis-tool.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-analysis-tool',
  templateUrl: './analysis-tool.component.html',
  styleUrls: ['./analysis-tool.component.scss'],
  standalone: false
})
export class AnalysisToolComponent implements OnInit {

  constructor(public analysisToolService: AnalysisToolService,
              public tabsService: TabsService,
              private modalService: ModalControlService,
              private pointsService: PointsService,
              private globalSelectionService: GlobalSelectionControlService) { }

  ngOnInit(): void {
  }


  showNavaidSelection(): boolean{
    return this.analysisToolService.isNavaidDiscreteCalculation() || this.analysisToolService.isPairsAnalysis();
  }


  onCheckBoxClick(navaid: string, event){
    if (this.analysisToolService.selectedNavaids.length <= 1 && !event.target.checked){
      this.modalService.showMesssageModal("Analysis Tool", "At least one NavAid must be selected.");
      event.target.checked = true;
      return;
    }
    if (event.target.checked){
      this.analysisToolService.selectedNavaids.push(navaid);
    } else {
      this.analysisToolService.selectedNavaids.splice(this.analysisToolService.selectedNavaids.indexOf(navaid), 1);
    }
  }

  updateMap(){
    this.analysisToolService.criticalNavaids = [];
    this.analysisToolService.deSelectFeatures();
    if (this.analysisToolService.isCritical()){
      this.analysisToolService.criticalNavaids.push(...this.analysisToolService.selectedNavaids);
      this.selectCriticalNavaidsOnMap();
    }
    this.analysisToolService.showHiddenFeatures();
    this.analysisToolService.hideExcludedFeatures();
  }

  showAll(){
    for (const navaid of this.analysisToolService.navaids_info.keys()){
      this.analysisToolService.selectedNavaids.includes(navaid) ? false : this.analysisToolService.selectedNavaids.push(navaid);
    }
    this.updateMap();
  }

  selectCriticalNavaidsOnMap(){
    for (const navOldId of this.analysisToolService.criticalNavaids){
      let splittedString: string[] = navOldId.split("_");
      let newSplittedString: string[]
      if (splittedString.length == 4){
        // deal with VOR_DME and DME_ILS splits
        newSplittedString = [];
        newSplittedString.push(splittedString[0]);
        newSplittedString.push(splittedString[1] + "_" + splittedString[2]);
        newSplittedString.push(splittedString[3]);
      }
      let navaidFeature: Feature<Geometry>;
      if (newSplittedString){
        navaidFeature = this.pointsService.getNavaidFeatureFromLayersWithOldId(newSplittedString[0], newSplittedString[1], newSplittedString[2]);
      } else {
        navaidFeature = this.pointsService.getNavaidFeatureFromLayersWithOldId(splittedString[0], splittedString[1], splittedString[2]);
      }

      if (navaidFeature){
        const layer : VectorLayerDMTR = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaidFeature.get("navaidtype").toLowerCase()).olLayer;
        this.analysisToolService.previouslySelectedFeatures.push(navaidFeature);
        this.globalSelectionService.selectNavaidOnMap(navaidFeature, layer);
      }

    }
  }

  //#region Grit
  public filterTransmitter(){
    let spoofing = document.getElementById("spoofing") as HTMLInputElement;
    let jamming = document.getElementById("jamming") as HTMLInputElement;

    this.analysisToolService.filterTransmitter(jamming.checked, spoofing.checked);
  }
  //endregion
}
